import { render, staticRenderFns } from "./MultiInput.vue?vue&type=template&id=6bf33718&scoped=true"
import script from "./MultiInput.vue?vue&type=script&lang=js"
export * from "./MultiInput.vue?vue&type=script&lang=js"
import style0 from "./MultiInput.vue?vue&type=style&index=0&id=6bf33718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf33718",
  null
  
)

export default component.exports